import { useSelector } from 'react-redux';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
} from '@mui/material';
import { RootState } from '../../configureStore';

interface BackDialogProps {
    open: boolean;
    onClose: () => void;
    onSaveAsDraft: () => void;
    onGoBack: () => void;
}

const BackDialog = ({
    open,
    onClose,
    onSaveAsDraft,
    onGoBack,
}: BackDialogProps) => {
    const isSaving = useSelector<RootState, boolean>(({ status: { loading: l } }) => l['returns/SAVE_EXTRACTION']);

    return (
        <Dialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
        >
            <DialogTitle>Unsaved Changes</DialogTitle>
            <DialogContent>
                <Typography variant="body1">
                    You have unsaved changes. Are you sure you want to go back? All unsaved progress will be lost.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                onClick={onSaveAsDraft}
                variant="outlined"
                color="primary"
                disabled={isSaving}
                >
                    {isSaving ? 'Saving...' : 'Save as Draft'}
                </Button>
                <Button
                onClick={onGoBack}
                variant="contained"
                color="error"
                >
                    Go Back
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default BackDialog;
